import { getPreferredPhone, useDeleteContact, useGetAllContacts } from "@api/contactService";
import { useEffect, useState } from "react";
import Box from '@mui/joy/Box';
import IconButton from '@mui/joy/IconButton';
import Tooltip from '@mui/joy/Tooltip';
import Typography from '@mui/joy/Typography';
import ObjectIndex from "@components/objects/ObjectIndex";
import LocalPhoneRoundedIcon from '@mui/icons-material/LocalPhoneRounded';
import EmailRoundedIcon from '@mui/icons-material/EmailRounded';

/*
interface HeadCell {
    disablePadding: boolean;
    id: keyof Data;
    label: string;
    numeric: boolean;
    sortable: boolean;
};
*/

const columns/*: readonly HeadCell[]*/ = [
    {
        id: 'name',
        numeric: false,
        disablePadding: true,
        sortable: true,
        label: 'Name',
        cell: (row, {LinkComponent}) => {
            // const LinkComponent = view === 'deleted' ? Box : Link;
            return (<>
                {row.name !== row.company_name && (<>
                    <LinkComponent to={`/contacts/${row.id}`} object={row}>
                    <Typography sx={{display: 'inline-block'}} fontWeight={'bold'}>{row.name}</Typography>
                    </LinkComponent>
                    {row.company_name && (<Typography fontSize="sm">{row.company_name}</Typography>)}
                </>)}
                {row.name === row.company_name && (<>
                    <LinkComponent to={`/contacts/${row.id}`} object={row}>
                    <Typography fontWeight={'bold'}>{row.company_name}</Typography>
                    </LinkComponent>
                </>)}
            </>)
        }
      },
      {
        id: 'email',
        numeric: false,
        disablePadding: false,
        sortable: true,
        label: 'Email',
        cell: (row) => row.email
      },
      {
        id: 'phone',
        numeric: false,
        disablePadding: false,
        sortable: false,
        label: 'Phone',
        cell: (row) => getPreferredPhone(row),
      },
];

const listCell = (row, {LinkComponent}) => {
    return (<>
    {row.name !== row.company_name && (
        <Box sx={{mb: 1}}>
            <Typography sx={{display: 'inline-block'}} fontWeight={'bold'}>
                <LinkComponent to={`/contacts/${row.id}`} object={row}>
                    {row.name}
                </LinkComponent>
            </Typography>
            {row.company_name && (<Typography fontSize="sm">{row.company_name}</Typography>)}
        </Box>
    )}
    {row.name === row.company_name && (
        <Box sx={{mb: 1}}>
            <Typography>
                <LinkComponent to={`/contacts/${row.id}`} object={row}>
                    {row.company_name}
                </LinkComponent>
            </Typography>
        </Box>
        )}
    </>);
};

const listActions = (row, {view, LinkComponent, ViewAction}) => {
    if(view === 'deleted') {
        return null;
    }

    return (<>
        <Tooltip title="Email">
            <IconButton
                size="sm"
                color="neutral"
                variant="outlined"
                sx={{ bgcolor: 'background.surface', ":disabled": {opacity: 0.3} }}
                disabled={!row.email}
                component={'a'}
                href={`mailto:${row.email}`}
                >
                <EmailRoundedIcon />
            </IconButton>
        </Tooltip>
        <Tooltip title="Call">
            <IconButton
                size="sm"
                color="neutral"
                variant="outlined"
                sx={{ bgcolor: 'background.surface', ":disabled": {opacity: 0.3} }}
                disabled={!getPreferredPhone(row)}
                component={'a'}
                href={`tel:${getPreferredPhone(row)}`}
                >
                <LocalPhoneRoundedIcon />
            </IconButton>
        </Tooltip>
    </>);
};

export default function ContactIndex() {
    return (
        <ObjectIndex
            query={useGetAllContacts}
            deleteMutation={useDeleteContact}
            type={'contact'}
            permissionType={'contacts'}
            title={'Contacts'}
            color={'contact'}
            columns={columns}
            listCell={listCell}
            listActions={listActions}
        />
    )
}
